import { createIcon } from "../create-icon"

export const PenIcon = createIcon({
  title: "PenIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M10.7794 7.58492L6.12155 12.2434H4L4 10.1224L8.65843 5.46396M10.7794 7.58492L12.7432 5.62079L10.6224 3.5L8.65843 5.46396M10.7794 7.58492L8.65843 5.46396"
      stroke="currentColor"
    />
  ),
})

PenIcon.displayName = "PenIcon"
